module.exports = __webpack_public_path__ + "img/manage.fff6b063.svg";